import React from "react";
import { Provider } from "react-redux";
import { Store } from "../../../../presentation/pages/mobile/Store";
import { storeItemStore } from "../../../../presentation/pages/mobile/Store/store";
import { makeDbLoadProductListByManyCodes } from "../../usecases/load-product-list-by-many-codes-factory";
import { makeDbLoadToBeStoredItems } from "../../usecases/load-to-be-stored-items-factory";

export const makeStore = () => {
  return (
    <Provider store={storeItemStore}>
      <Store
        loadToBeStoredItems={makeDbLoadToBeStoredItems()}
        loadProductListByManyCodes={makeDbLoadProductListByManyCodes()}
      />
    </Provider>
  );
};
